import React from "react";
import { Link } from "lib/components/vendor";

const OrderCustomerLink = ({
  order,
  label,
  placeholder = I18n.t("papp.order.customer_name_placeholder"),
  currentCompanyId,
  ...props
}) => {
  const orderCustomerId =
    order.company.id === currentCompanyId
      ? order.customer_id
      : order.agent && order.agent.id === currentCompanyId
      ? order.agent_customer_id
      : null;
  label = label || order.customer_full_name || placeholder;
  return orderCustomerId ? (
    <Link to={`/c/${currentCompanyId}/customers/${orderCustomerId}`} {...props}>
      {label}
    </Link>
  ) : (
    <span {...props}>{label}</span>
  );
};

export default OrderCustomerLink;



// WEBPACK FOOTER //
// ./src/lib/components/OrderCustomerLink.jsx